<!-- Return Requests -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-undo-alt"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Return Requests</h1>
        <p class="page-description">Review and manage pending item return requests</p>
      </div>
    </div>
  </div>
</div>

<!-- Return Request Card -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <div class="title-content">
        <div class="title-text">Pending Return Request</div>
        <div class="title-subtitle">Return request from Table 007</div>
      </div>
    </div>
    <div>
      <span style="font-size: 12px; color: var(--text-tertiary);">
        <i class="fas fa-clock me-1"></i>1 min ago
      </span>
    </div>
  </div>

  <div class="panel-body" style="padding: 24px;">
    <div class="row g-4">
      <div class="col-sm-6 col-md-3">
        <div style="margin-bottom: 4px;">
          <span style="font-size: 11px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Order ID</span>
        </div>
        <div style="font-size: 14px; font-weight: 600; color: var(--text-primary);">0123485762</div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div style="margin-bottom: 4px;">
          <span style="font-size: 11px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Waiter</span>
        </div>
        <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">Flora Ikuigbe</div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div style="margin-bottom: 4px;">
          <span style="font-size: 11px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Reason</span>
        </div>
        <div>
          <span class="badge badge-dot badge-soft-danger">Expired Item</span>
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div style="margin-bottom: 4px;">
          <span style="font-size: 11px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Item</span>
        </div>
        <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">Sprite Lemon 50cl bottle</div>
      </div>
    </div>

    <div style="margin-top: 24px; padding-top: 20px; border-top: 1px solid var(--border); display: flex; gap: 10px; flex-wrap: wrap;">
      <button class="btn btn-primary" (click)="acceptReturn()">
        <i class="fas fa-check me-1"></i>Accept Return
      </button>
      <button class="btn btn-outline-secondary" (click)="rejectReturn()">
        <i class="fas fa-times me-1"></i>Reject Return
      </button>
    </div>
  </div>
</div>
